export class UnSupportedBrowser {
  id: any;
  heading: any;
  title: any;
  browserDescription: any;
  ctaLabel: any;
  ctaUrl: any;
  disclaimerText: any;
  footnoteTitle: any;
  footnoteDescription: any;
  browserIconValues: any;
  browserIconLogo: any;
  browserIconLink: any;
  browserIconTarget: any;
  iconText: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      } else {
        this.id = '';
      }
      if (contentjson['heading']) {
        this.heading = contentjson['heading'];
      } else {
        this.heading = '';
      }
      if (contentjson['title']) {
        this.title = contentjson['title'];
      } else {
        this.title = '';
      }
      if (contentjson['browserDescription']) {
        this.browserDescription = contentjson['browserDescription'];
      } else {
        this.browserDescription = '';
      }
      if (contentjson['ctaLabel']) {
        this.ctaLabel = contentjson['ctaLabel'];
      } else {
        this.ctaLabel = '';
      }
      if (contentjson['ctaUrl']) {
        this.ctaUrl = contentjson['ctaUrl'];
      } else {
        this.ctaUrl = '';
      }
      if (contentjson['disclaimerText']) {
        this.disclaimerText = contentjson['disclaimerText'];
      } else {
        this.disclaimerText = '';
      }
      if (contentjson['footnoteTitle']) {
        this.footnoteTitle = contentjson['footnoteTitle'];
      } else {
        this.footnoteTitle = '';
      }
      if (contentjson['footnoteDescription']) {
        this.footnoteDescription = contentjson['footnoteDescription'];
      } else {
        this.footnoteDescription = '';
      }
      if (contentjson['browserIconValues']) {
        this.browserIconValues = contentjson['browserIconValues'];
      } else {
        this.browserIconValues = '';
      }
      if (contentjson['browserIconLogo']) {
        this.browserIconLogo = contentjson['browserIconLogo'];
      } else {
        this.browserIconLogo = '';
      }
      if (contentjson['browserIconLink']) {
        this.browserIconLink = contentjson['browserIconLink'];
      } else {
        this.browserIconLink = '';
      }
      if (contentjson['browserIconTarget']) {
        this.browserIconTarget = contentjson['browserIconTarget'];
      } else {
        this.browserIconTarget = '';
      }
      if (contentjson['iconText']) {
        this.iconText = contentjson['iconText'];
      } else {
        this.iconText = '';
      }
    }
  }
}
